<template>
	<CommonLoading
		v-if="loading"
	/>
	<FilterComponent
		:title="'Visitas'"
		:open="openFilter"
		:fields="filterFields"
		:activeFilters= "filters"
		@apply-filters="handleFilters"
		@update-open="openFilter = false"
	/>
	<CommonListing
		:listingData = "data"
		:headersData = "headers"
		:headerInfo = "headerInfo"
		:inputsListing= "inputs"
		:previous = "previous"
		:next = "next"
		:currentPage = "currentPage"
		:totalPages = "totalPages"
		:totalRecords = "totalRecords"
		:resetFormData= "resetFormData"
		:editFormData= "editFormData"
		:importFile= "false"
		:useForms= "false"
		:fileOnly="false"
		:hideDelete="true"
		:hideView="true"
		@previous-page= "pageData"
		@next-page= "pageData"
		@go-to-page= "goTo"
		@edit-alternative= "getEditData"
		@filter="openFilter = true"
	/>
	<TodasVisitasForm
		:open= "editingOpen"
		:placeHolderValues= "editFormData"
		:consultores="consultores"
		@editing-data= "onSendEditingData"
		@update-open= "editingOpen = false"
	/>
</template>
<script>

import { pageVariables } from '@/views/insideviews/todas_visitas/PageVariablesTodasVisitas';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import TodasVisitasRepository from '@/services/TodasVisitasRepository.vue';
import TodasVisitasForm from './TodasVisitasForm.vue';
import FilterComponent from "@/components/generalcomponents/CommonFilter.vue";
import CommonLoading from '@/components/generalcomponents/CommonLoading';
import Swal from "sweetalert2";
import GruposRepository from '@/services/GruposRepository.vue';
import CommonListing from '@/components/generalcomponents/CommonListing.vue';

export default {
	name: 'TodasVisitasView',
	async created(){
		this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
		await this.$nextTick(); 
		this.pageData(this.getListas);
		this.getConsultores();
	},
	data() {
		return {
			...pageVariables,
			data: [],
			previous: '',
			next: '',
			totalPages: 0,
			totalRecords: 0,
			currentPage: 0,
			loading : false, 
			resetFormData: false,
			editFormData:{},
			editingOpen: false,
			onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
			openFilter: false,
			filters: {},
			actualPage: '',
			editingListaId: '',
			consultores: [],
			
			// Fields for the CommonListing component configuration
			headers: ['Segurado / Dependente', 'Consultor', 'Agendamento', 'Status da Visita', 'Data da Visita', 'Ações'],
			headerInfo: ['segurado', 'consultor_email', 'agendamento', 'status_visita'],
			inputs: [], // No create inputs since useForms is false

			filterFields: [
				{
					name: "consultor_email",
					label: "Consultor",
					type: "input",
					placeholder: "Digite o email do consultor"
				},
				{
					name: "endereco",
					label: "Endereço",
					type: "input",
					placeholder: "Digite o endereço"
				},
				{
					name: "data_visita",
					label: "Data de Visita",
					type: "date",
					placeholder: "Selecione a data de visita"
				},
				{
					name: "status_visita",
					label: "Status da Visita",
					type: "input",
					placeholder: "Digite o status"
				},
				{
					name: "nome",
					label: "Nome Segurado",
					type: "input",
					placeholder: "Digite o nome do segurado"
				}
			]
		};
	},
	methods: {
		async pageData(page){
			this.actualPage = page;
			this.loading = true; 
			const listaRepo = new TodasVisitasRepository();
			try {
				const response = await listaRepo.getListas(page, this.onlineUser.token, this.filters);
				if (response?.status  === 200) {
					this.data = response.data.data;
					this.totalPages = response.data.last_page;
					this.totalRecords = response.data.total;
					this.currentPage = response.data.current_page;
					
					if (response.data.next_page_url) {
						this.next = response.data.next_page_url;
					}else{
						this.next = ""
					}
					if (response.data.prev_page_url) {
						this.previous = response.data.prev_page_url;
					}else{
						this.previous = ""
					}
					this.loading = false; 
				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
			}
		},
		async onSendEditingData(data, id) {
			this.loading = true; 
			const listaRepo = new TodasVisitasRepository();

			try {
				// We send the update to the updateLista endpoint (which is the ListaDeAgendamento update)
				// The ID is the lista_de_agendamento_id!
				const response = await listaRepo.updateLista(this.updateLista, this.onlineUser.token, id, data);
				if (response?.status === 200) {
					this.editingOpen = false;
					this.pageData(this.actualPage);
					this.mostrarAlerta();
					this.loading = false; 
				} else {
					this.loading = false; 
					this.error = response?.message;
					this.mostrarAlertaErro(this.error);
				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
			}
		},
		async getEditData(id) {
			this.loading = true;
			const listaRepo = new TodasVisitasRepository();
			try {
				// Busca a FichaVisitaCompleta através do ID passado no parâmetro
				const response = await listaRepo.getLista(this.getFichaCompleta, this.onlineUser.token, id);
				
				if (response?.status === 200) {
					const ficha = response.data;
					this.editFormData = {
						id: ficha.lista_de_agendamento_id, // Usado para fazer a requisição de update
						consultor_email: ficha.consultor_email,
						data_visita: ficha.data_visita,
						observacoes: ficha.observacoes || [],
						timeline: ficha.timeline || []
					};
					this.editingOpen = true;
				} else {
					this.mostrarAlertaErro(response?.message || "Erro ao buscar detalhes da visita.");
				}
			} catch (error) {
				handleUnauthorized(error);
				this.mostrarAlertaErro("Erro de conexão ao buscar os detalhes da visita.");
			} finally {
				this.loading = false;
			}
		},
		async getConsultores(){
			const groupsRepo = new GruposRepository();
			try {
				const response = await groupsRepo.getGroupMembers(this.onlineUser.token, this.consultoresPage);
				if (response?.status === 200) {
					this.consultores = response.data;
				}
			} catch (error) {
				console.error("Erro ao buscar consultores", error);
			}	
		},
		goTo(number){
			this.pageData(this.getListas+"?page="+number)
		},
		handleFilters(rawFilters) {
			this.filters = rawFilters;
			this.openFilter = false;
			this.pageData(this.getListas);
		},
		mostrarAlerta() {
			Swal.fire({
				icon: 'success',
				title: 'Sucesso!',
				text: 'A operação foi concluída com sucesso.',
				confirmButtonColor: '#3085d6',
			});
		},
		mostrarAlertaErro(message) {
			Swal.fire({
				icon: 'error',
				title: 'Erro!',
				text: message || "Ocorreu um erro.",
				confirmButtonColor: '#3085d6', 
			});
		},
	},
	components:{
		TodasVisitasForm,
		FilterComponent,
		CommonLoading,
		CommonListing
	}
}
</script>

<style scoped>
</style>
